<template>
    <div class="d-flex flex-column">
      <filtered-data
        ref="data"
        v-model="data"
        endpoint="news"
        :filtersValue="filtersValue"
        :loading.sync="loading"
        :hasMore.sync="hasMore"
        :date="date"
      />
  
      <div class="container-fluid">
        <div class="d-flex align-items-center">
          <div class="mr-auto"><h1>Новости</h1></div>
          <filter-range-date v-model="date" class="mr-2" style="max-width: 26em;"/>
        </div>
      </div>
  
      <template v-if="data && data.data">
        <data-table-full-height
          :data="data.data"
          :hasMore="hasMore"
          :loading="loading"
          @load-more="$refs.data.loadMore"
          @filter-change="refreshFilters"
        >
          <el-table-column type="expand">
            <template slot-scope="{row}">
              <div class="modem-command-details-expand">
                <news-list-details :news="row"></news-list-details>
              </div>
            </template>
          </el-table-column>
        <table-column-date prop="created_at" label="Дата"/>
          <el-table-column prop="title" label="Заголовок">
            <template slot-scope="{row}">
              <pre v-if="row.title" class="modem-command-data-result-preview m-0"
              >{{ row.title.trim() }}</pre>
            </template>
          </el-table-column>
        </data-table-full-height>
      </template>
    </div>
  </template>
  
  <script>
    import moment from 'moment'
    import api from '@/api'
    import FilterRangeDate from '../../components/filter-range-date'
  
    export default {
      metaInfo () {
        return {title: `Новости`}
      },
      components: {FilterRangeDate},
      data () {
        return {
          filtersValue: {},
          data: {},
          loading: false,
          hasMore: true,
          date: {},
        }
      },
      asyncComputed: {
      },
      filters: {
      },
      methods: {
        refreshFilters (event) {
          this.filtersValue = Object.assign({}, this.filtersValue, event)
        },
      },
    }
  </script>
  
  <style lang="scss" scoped>
    @import "boot";
    .modem-command-data-result-preview {
      @include text-overflow-lines(2);
      position: relative;
      &:after {
        content: '';
        position: absolute;
        bottom: -1px;
        left: 0;
        width: 100%;
        height: .6em;
        pointer-events: none;
        @include gradient-y(rgba(#fff, 0), rgba(#fff, .3));
      }
    }
    .modem-command-details-expand .modem-command-data-result {
      max-height: 29.5 * $line-height-base * 1em;
    }
.has-gutter {
  display: none;
}
  </style>


// WEBPACK FOOTER //
// resources/assets/js/pages/news/index.vue